import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({ formData, onInputChange, genderList, userList, salutationList, errors }) => {
    const statusList = [
        { name: 'Passive' },
        { name: 'Open' },
        { name: 'Replied' },

    ];
    return (
        <>
            <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
                <div className="col-12">
                    <p className="boxLabel m-0">Contact Details</p>
                </div>


                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>


                        <div className={errors.solution ? `mb-3 errorborder` : `mb-3`}>

                            <SelectSearch
                                list={salutationList}
                                label="salutation"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.solution}
                                onChange={(value) => onInputChange('solution', value)}
                                placeholder=""

                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Firstname"
                                label="Firstname"
                                style={{ height: "30px" }}
                                value={formData.firstname}
                                onChange={(e) => onInputChange('firstname', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="lastname"
                                label="Lastname"
                                style={{
                                    height: "30px",
                                    ...(errors?.lastname ? { border: '1px solid red' } : {})
                                }}
                                value={formData.abbr}
                                onChange={(e) => onInputChange('lastname', e.target.value)}

                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>

                        <div className={errors.gender ? `mb-3 errorborder` : `mb-3`}>
                            <SelectSearch
                                list={genderList}
                                label="Gender"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.gender}
                                onChange={(value) => onInputChange('gender', value)}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>


                        <div className={errors.userid ? `mb-3 errorborder` : `mb-3`}>
                            <SelectSearch
                                list={userList}
                                label="User id"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.userid}
                                onChange={(value) => onInputChange('userid', value)}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Address"
                                label="Address"
                                style={{
                                    height: "30px",
                                    ...(errors?.address ? { border: '1px solid red' } : {})
                                }}
                                value={formData.address}
                                onChange={(e) => onInputChange('address', e.target.value)}
                            />
                        </div>
                    </div>
                </div>


                {/* second raw end  */}


                {/* thrid raw */}
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Designation"
                                label="Designation"
                                style={{ height: "30px" }}
                                value={formData.designation}
                                onChange={(e) => onInputChange('designation', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Company Name"
                                label="Company Name"
                                style={{ height: "30px" }}
                                value={formData.company_name}
                                onChange={(e) => onInputChange('company_name', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className={errors.status ? `mb-3 errorborder` : `mb-3`}>
                            <SelectSearch
                                list={statusList}
                                label="Status"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.status}
                                onChange={(value) => onInputChange('status', value)}
                                placeholder=""
                            />
                        </div>
                    </div>
                </div>
                {/* thrid raw end */}

                {/* google check box */}

                <div style={{ marginBottom: '12px', display: 'flex', gap: '150px', padding: '0 12px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: '400px', marginBottom: '18px' }}>
                        <input
                            type="checkbox"
                            checked={formData.is_google || false}
                            onChange={(e) => {
                                console.log('Checkbox changed to:', e.target.checked);
                                onInputChange('is_google', e.target.checked);
                            }}
                            className="form-check-input me-2"
                            style={{
                                width: '15px', height: '15px',
                                backgroundColor: formData.isGroupWarehouse ? '#270B79' : 'white',

                                borderColor: "#270B79"
                            }}
                        />
                        Sync with Google Contacts
                    </label>
                </div>
            </div>
        </>
    );
};

export default Tab1;